let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("becB8"), load("axWnt")]).then(() => parcelRequire('dLvuL'));